<template>
    <!-- 单选组件 -->
    <el-radio-group 
    v-model="value" 
    :size="size" 
    :disabled="disabled"
    :text-color="textColor" 
    :fill="fill"
    @change="change">
        <template v-for="radio in radioList">
            <!-- 普通类型 -->
            <el-radio 
            v-if="!radio.btn" 
            :label="radio.label" 
            :key="radio.label" 
            :disabled="radio.disabled"
            :size="radio.size"
            :border="radio.border"
            >
                <slot :text="radio">{{radio.text}}</slot>
            </el-radio>
            <!-- 按钮类型 -->
            <el-radio-button 
            v-else
            :label="radio.label" 
            :key="radio.label" 
            :disabled="radio.disabled"
            >
                <slot :text="radio">{{radio.text}}</slot>
            </el-radio-button>
        </template>
    </el-radio-group>
</template>
<script>
export default {
    name:"VelRadio",
    props:{
        size:String,
        isDisable:Boolean,
        textColor:String,
        fill:String,
        radioList:{
            type:Array,
            required:true,
        },
        initValue:[String,Number,Boolean],
    },
    data() {
        return {
            value:'',
            disabled:false,
        };
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return
                this.value = newval
            },
            deep:true,
            immediate:true,
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isDisabled ? this.disabled = true : this.disabled
        },
        change(val){
            this.$emit('radioChange',val)
        },
        getValue(){
            this.initValue ? this.value = this.initValue : 
            this.value = this.radioList[0].label
        }
    },
}
</script>